import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

// 🔹 Hook is defined here inside the same file
export const useSuccessDialog = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const showSuccess = (msg: string) => {
    setMessage(msg);
    setOpen(true);
  };

  const closeSuccess = () => setOpen(false);

  return { open, message, showSuccess, closeSuccess };
};

interface SuccessDialogProps {
  open: boolean;
  message: string;
  onClose?: () => void;
}

const SuccessDialog: React.FC<SuccessDialogProps> = ({ open, message, onClose }) => {
  useEffect(() => {
    if (open && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [open, onClose]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent sx={{ textAlign: "center", p: 4 }}>
        <CheckCircleIcon color="success" sx={{ fontSize: 50 }} />
        <Typography mt={2} fontSize="16px" fontFamily="Poppins, Regular">
          {message}
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessDialog;
